import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'svg[mib-play-icon]',
  template: `
    <svg:path
      d="M11.375 8L4.0625 3.29688V12.7031L11.375 8ZM2.75 2.09375L2.76562 1.95312L2.8125 1.82812L2.875 1.71875L2.95312 1.60938L3.0625 1.54688L3.17188 1.48438L3.29688 1.45312L3.42188 1.4375H3.5L3.59375 1.46875L3.67188 1.5L3.76562 1.54688L12.9531 7.45312L13.0156 7.5L13.0781 7.5625L13.125 7.625L13.1719 7.6875L13.2031 7.76562L13.2344 7.84375L13.25 7.92188V8V8.07812L13.2344 8.15625L13.2031 8.23438L13.1719 8.3125L13.125 8.375L13.0781 8.4375L13.0156 8.5L12.9531 8.54688L3.76562 14.4531L3.67188 14.5L3.59375 14.5312L3.5 14.5625H3.42188H3.32812L3.25 14.5469L3.17188 14.5156L3.09375 14.4844L3.01562 14.4375L2.95312 14.375L2.89062 14.3125L2.84375 14.25L2.8125 14.1719L2.78125 14.0938L2.75 14V13.9062V2.09375Z" />
  `,
  host: {
    '[attr.viewBox]': 'viewBox()',
    class: 'mib-icon-default-size fill-current transition-colors',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PlayIcon {
  readonly viewBox = input<string>('0 0 16 16');
}
